const REFRESH_PROFILE_TEMP_SUCCESS = 'app/auth/profile_temp/refresh/success';

export { REFRESH_PROFILE_TEMP_SUCCESS };
